import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import Logo from "@/components/Logo";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(typeof err?.response?.data?.detail === "string" ? err.response.data.detail : "Please enter a valid email address"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F9FE] px-4">
      <Card className="w-full max-w-md p-8 bg-white border-slate-200 shadow-lg">
        <Link to="/" className="flex items-center gap-2 mb-6"><Logo size={44} /><span className="font-display font-extrabold text-[#0A2A5E] text-lg">LUMIS HR</span></Link>
        <h1 className="font-display text-2xl font-bold text-[#0A2A5E]">Reset your password</h1>
        {sent ? (
          <div data-testid="forgot-sent" className="mt-4 p-4 rounded-lg bg-[#F5F9FE] border border-slate-200 text-sm text-slate-700 flex gap-3">
            <MailCheck className="w-5 h-5 text-emerald-600 flex-shrink-0" />
            <div>If an account exists for <strong>{email}</strong>, a reset link has been sent. It is valid for 60 minutes and can be used once. Check your spam folder if it does not arrive.</div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4">
            <p className="text-sm text-slate-600">Enter the email on your account and we'll send you a secure link to choose a new password.</p>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white h-11">{busy ? "Sending…" : "Send reset link"}</Button>
          </form>
        )}
        <div className="mt-6 text-sm text-center text-slate-600"><Link to="/login" data-testid="back-to-login" className="text-[#0A2A5E] font-semibold hover:underline">Back to sign in</Link></div>
      </Card>
    </div>
  );
}
